// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_grid_container__cSUtc {
  display: flex;
  gap: 2rem;
  justify-content: center;
  align-items: center;
  width: 100% !important;
}

.styles_card_container__ium4a {
  border-radius: 10px;
  box-shadow: 2px 2px 5px #cecece;
  /* padding: 2.5rem 1rem 3rem 1rem; */
  position: relative;
  width: 27rem;
  /* width: 48%; */
}

.styles_card_container__ium4a strong {
  margin-right: 0.5rem;
}

.styles_card_text__9\\+qnn{
    display: flex;
    overflow-y: auto;
}


.styles_card_header__WB7ML {
  background: #18316e;
  border-radius: 10px 10px 0 0;
  box-shadow: 2px 0 5px #cecece;
  color: white;
  left: 0;
  padding: 0.3rem 1rem;
  position: block;
  top: 0;
  width: 100%;
}

.styles_card_content__-fRrZ{
  max-height: 13rem;
  overflow-y: auto;
  padding: 0.7rem;
}

.styles_card_buttons__x5yQE {
  border-radius: 0 0px 10px 10px;
  border-top: 1px solid #18316e;
  bottom: 0;
  display: flex;
  left: 0;
  position: inline;
  width: 100%;
}

.styles_card_buttons__x5yQE button {
  align-items: center;
  background: none;
  border: none;
  color: #18316e;
  display: flex;
  justify-content: center;
  padding: 0.5rem;
  text-align: center;
  width: 100%;
}

.styles_card_buttons__x5yQE button:hover {
  background: #ececec;
  cursor: pointer;
}

.styles_card_buttons__x5yQE span {
  margin-right: 0.5rem;
}

@media screen and (max-width: 769px) {
  .styles_container__botqp {
    justify-content: space-around;
  }
  .styles_card_container__ium4a {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/TableCard/CardView/styles.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,oCAAoC;EACpC,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;;AAGA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,6BAA6B;EAC7B,YAAY;EACZ,OAAO;EACP,oBAAoB;EACpB,eAAe;EACf,MAAM;EACN,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,SAAS;EACT,aAAa;EACb,OAAO;EACP,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,WAAW;EACb;AACF","sourcesContent":[".grid_container {\n  display: flex;\n  gap: 2rem;\n  justify-content: center;\n  align-items: center;\n  width: 100% !important;\n}\n\n.card_container {\n  border-radius: 10px;\n  box-shadow: 2px 2px 5px #cecece;\n  /* padding: 2.5rem 1rem 3rem 1rem; */\n  position: relative;\n  width: 27rem;\n  /* width: 48%; */\n}\n\n.card_container strong {\n  margin-right: 0.5rem;\n}\n\n.card_text{\n    display: flex;\n    overflow-y: auto;\n}\n\n\n.card_header {\n  background: #18316e;\n  border-radius: 10px 10px 0 0;\n  box-shadow: 2px 0 5px #cecece;\n  color: white;\n  left: 0;\n  padding: 0.3rem 1rem;\n  position: block;\n  top: 0;\n  width: 100%;\n}\n\n.card_content{\n  max-height: 13rem;\n  overflow-y: auto;\n  padding: 0.7rem;\n}\n\n.card_buttons {\n  border-radius: 0 0px 10px 10px;\n  border-top: 1px solid #18316e;\n  bottom: 0;\n  display: flex;\n  left: 0;\n  position: inline;\n  width: 100%;\n}\n\n.card_buttons button {\n  align-items: center;\n  background: none;\n  border: none;\n  color: #18316e;\n  display: flex;\n  justify-content: center;\n  padding: 0.5rem;\n  text-align: center;\n  width: 100%;\n}\n\n.card_buttons button:hover {\n  background: #ececec;\n  cursor: pointer;\n}\n\n.card_buttons span {\n  margin-right: 0.5rem;\n}\n\n@media screen and (max-width: 769px) {\n  .container {\n    justify-content: space-around;\n  }\n  .card_container {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid_container": `styles_grid_container__cSUtc`,
	"card_container": `styles_card_container__ium4a`,
	"card_text": `styles_card_text__9+qnn`,
	"card_header": `styles_card_header__WB7ML`,
	"card_content": `styles_card_content__-fRrZ`,
	"card_buttons": `styles_card_buttons__x5yQE`,
	"container": `styles_container__botqp`
};
export default ___CSS_LOADER_EXPORT___;
